import { ThemeOverride } from "@chakra-ui/react";

export const borders: ThemeOverride["borders"] = {
  "3px": "3px solid",
};
